export const drawerWidth = 270;

export const LANGUAGE_ITEM_KEY = 'language_key';
